import React, { useCallback, useEffect, useState } from 'react';
import { BasecampLayout } from '../../components/Layout';
import { PageHeader, Card, Spinner, Alert, Table, Btn, Input, Select } from '../../components/UI';
import { api } from '../../utils/api';

// Hike administration — radno mesto funkcije (Faza 2).
// Pickup community zahteva (interest votes) + kreiranje strateških Hike-ova;
// svaki objavljen Hike se pojavljuje u News & Calendar.

export default function HikeAdmin() {
  const [state, setState] = useState({ loading: true, error: null, events: [] });
  const [form, setForm] = useState({ title: '', when: '', format: 'online' });
  const [sched, setSched] = useState({});

  const load = useCallback(() => {
    api.getEvents()
      .then(d => setState({ loading: false, error: null, events: d.events }))
      .catch(e => setState({ loading: false, error: e.message, events: [] }));
  }, []);
  useEffect(() => { load(); }, [load]);

  async function schedule(id) {
    const when = sched[id];
    if (!when || !when.trim()) { alert('Enter the time slot (e.g. "12 Oct · 2h").\nUnesi termin (npr. "12 Oct · 2h").'); return; }
    try {
      await api.updateEvent(id, { whenText: when, status: 'scheduled', organiserSelf: true });
      load();
    } catch (e) { alert(e.message); }
  }

  async function createStrategic(e) {
    e.preventDefault();
    if (!form.title.trim() || !form.when.trim()) return;
    try {
      await api.createEvent({ title: form.title, whenText: form.when, format: form.format, kind: 'hike' });
      setForm({ title: '', when: '', format: 'online' });
      load();
    } catch (err) { alert(err.message); }
  }

  const hikes = state.events.filter(e => e.kind === 'hike');
  const requested = hikes.filter(e => e.status === 'requested');
  const scheduled = hikes.filter(e => e.status !== 'requested');

  return (
    <BasecampLayout>
      <PageHeader
        title="Hike administration"
        subtitle="Pick up community requests, create strategic Hikes, announce them — every published Hike lands in News & Calendar"
      />
      {state.loading ? <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}><Spinner /></div>
        : state.error ? <Alert type="error">{state.error}</Alert> : (
        <>
          <Card style={{ padding: '18px 22px', marginBottom: 24 }}>
            <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '1.05rem', marginBottom: 10 }}>Requests awaiting pickup</h3>
            <Table
              headers={['Topic', 'Initiated by', 'Interested', 'Schedule (date/format)', '']}
              rows={requested.map(h => [
                <b>{h.title}</b>,
                h.initiatedBy || '—',
                h.votes,
                <Input placeholder='npr. "12 Oct · 2h"' value={sched[h.id] || ''} onChange={e => setSched(s => ({ ...s, [h.id]: e.target.value }))} style={{ maxWidth: 170, padding: '6px 10px' }} />,
                <Btn size="sm" onClick={() => schedule(h.id)}>Schedule & announce</Btn>,
              ])}
              emptyMessage="No open requests."
            />
          </Card>

          <Card style={{ padding: '18px 22px', marginBottom: 24 }}>
            <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '1.05rem', marginBottom: 10 }}>Create a Hike (strategic development)</h3>
            <form onSubmit={createStrategic} style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
              <Input placeholder="Topic" value={form.title} onChange={e => setForm(f => ({ ...f, title: e.target.value }))} style={{ flex: 2, minWidth: 200 }} />
              <Input placeholder="Date (e.g. 12 Oct)" value={form.when} onChange={e => setForm(f => ({ ...f, when: e.target.value }))} style={{ flex: 1, minWidth: 130 }} />
              <Select value={form.format} onChange={e => setForm(f => ({ ...f, format: e.target.value }))} style={{ maxWidth: 120 }}>
                <option value="online">online</option>
                <option value="onsite">onsite</option>
              </Select>
              <Btn type="submit">Create & announce</Btn>
            </form>
          </Card>

          <Card style={{ padding: '18px 22px' }}>
            <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '1.05rem', marginBottom: 10 }}>All scheduled Hikes</h3>
            <Table
              headers={['Topic', 'When', 'Origin', 'Organiser', 'Signed up']}
              rows={scheduled.map(h => [h.title, h.when || '—', h.origin, h.organiser || '—', h.signups])}
              emptyMessage="No scheduled Hikes"
            />
          </Card>
        </>
      )}
    </BasecampLayout>
  );
}
